import React from "react";
import {Config} from "../Config";

export var monthName = ["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."];
export var monthNameEn = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export var monthFullName = ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"];
export var monthFullNameEn = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export var dayName = ["อ.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];
export var dayNameEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export var dayFullName = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];
export var dayFullNameEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export var validateNumber = /^[0-9]*$/;
export var englishCheck = /^[A-Za-z0-9_]*$/;
//export var validateEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export var validateEmail = /\S+@\S+\.\S+/;
export var strengthPassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,}$/;
export var randomString = Math.random().toString(36).slice(2, 7);
export var random5Number = Math.floor(Math.random()*90000) + 10000;

export var slugString = (str) => {
    return str.replace(/[^a-zA-Z0-9ก-๙-]+/g,'-');
};

export function cleanInput(str) {
    if(str) {
        let newStr = str.replace(/<[^>]*>/g, '');
        newStr = newStr.replace(/'/g, "\\'");
        newStr = newStr.trim();
        return newStr;
    }
    else {
        return str;
    }
}

export function cleanOutput(str) {
    if(str) {
        str = str.replace(/\\/g, '');
    }
    return str;
}

export var dateTime = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();

        hour = (hour < 10 ? '0':'') + hour;
        minute = (minute < 10 ? '0':'') + minute;

        return <>{day}/{month}/{year}<span className="small d-block text-muted">{hour}:{minute}</span></>;
    }
    else {
        return '';
    }
};

export var dateDMY = (dateTimeUTC, lang = 'th', isFull = true) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();

        let mName = lang === 'en' ? (isFull ? monthFullNameEn[month]:monthNameEn[month]):(isFull ? monthFullName[month]:monthName[month]);
        let yearName = lang === 'en' ? year:year + 543;

        return <>{day} {mName} {yearName}</>;
    }
    else {
        return '';
    }
};

export var getDay = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let day = date.getDate();

        return day < 10 ? '0' + day : day;
    }
    else {
        return '';
    }
};

export var getMonthYearShort = (dateTimeUTC, lang = 'th') => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth();

        let mName = lang === 'en' ? monthNameEn[month]:monthName[month];
        let yearName = lang === 'en' ? year:year + 543;

        return <>{mName} {yearName.toString().substr(2, 2)}</>;
    }
    else {
        return '';
    }
};

export var getDetailDate = (dateTimeUTC, lang = 'th') => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();

        hour = (hour < 10 ? '0':'') + hour;
        minute = (minute < 10 ? '0':'') + minute;

        //วันที่ 15 กันยายน 2568 เวลา 18:20:22
        return (lang === 'en' ? '':'วันที่ ') +  day + ' ' + (lang === 'en' ? monthFullNameEn[month]:monthFullName[month]) + ' ' + (lang === 'en' ? year:year+543) + (lang === 'en' ? '':' เวลา ') + hour + ':' + minute;
    }
    else {
        return '';
    }
};

export var encodeItem = (json) => {
    return window.btoa(encodeURIComponent(JSON.stringify(json)));
};

export var decodeItem = (encodeStr) => {
    let str = decodeURIComponent(window.atob(encodeStr));
    return JSON.parse(str);
};